var _path, _ellipse;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBenepassWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.7988 10.8781C28.7988 13.0293 27.3867 14.9196 25.2561 15.9998C27.3867 17.0801 28.7988 18.9703 28.7988 21.1216C28.7988 24.4785 25.3604 27.1998 21.1188 27.1998H9.24414V4.79986H19.7826C19.7946 4.79982 19.8066 4.7998 19.8186 4.79981C19.8445 4.79983 19.888 4.79985 19.944 4.79986H20.4094C20.5428 4.79986 20.6813 4.79988 20.8065 4.79988L21.1188 4.79986C25.3604 4.79986 28.7988 7.52118 28.7988 10.8781Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.27536,
    cy: 16.1231,
    rx: 6.07614,
    ry: 6.07822,
    fill: "#ED0E61"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenepassWhite);
export default __webpack_public_path__ + "static/media/benepass-white.608c8fecc42495a1507f746757d0c058.svg";
export { ForwardRef as ReactComponent };